<template>
  <ReportModal :item-id="currentId" origin="mallStore"></ReportModal>
  <div class="my-10 flex flex-col gap-5">
    <div class="">
      <div v-if="bannersLoaded">
        <Splide
          @splide:move="stopVideo"
          ref="splide"
          class="w-full"
          :options="{
            slideFocus: true,
            type: 'loop',
            autoplay: false,
            pagination: false,
            pauseOnHover: false,
          }"
          :has-track="false"
          aria-label="similars"
        >
          <SplideTrack class="py-4">
            <SplideSlide v-for="el in detail?.medias" :key="keyvideo[`video${el.id}`]">
              <video
                controlsList="nodownload"
                v-if="isVideo(el.path)"
                :ref="'video' + el.id"
                controls
                :src="el?.path"
                class="object-contain h-[450px] w-full"
              ></video>
              <img
                v-else
                class="rounded-t h-[450px] w-full object-fill"
                :src="el?.path"
                alt="store-banner"
              />
            </SplideSlide>
          </SplideTrack>
        </Splide>
      </div>
      <div
        class="rounded-lg bg-white mb-4 flex items-center gap-10 p-4 min-w-0 max-lg:flex-wrap max-lg:gap-3"
        :class="{ 'bg-gradient-to-br from-[#ECECFE] to-[#D3D5FD]': detail?.is_vip }"
      >
        <h1
          class="font-bold text-2xl text-main-color min-w-0 flex-1 truncate"
          :title="detail?.name"
        >
          {{ detail?.name }}
        </h1>

        <button
          v-if="detail?.subscription !== ''"
          class="w-max rounded-lg px-8 font-bold shrink-0"
          :class="getSubcriptionType?.color"
        >
          {{ getSubcriptionType?.name }}
        </button>
        <div
          v-if="detail?.is_vip"
          class="px-8 bg-[#7951F9] rounded-lg text-white font-bold text-2xl text-end shrink-0"
        >
          VIP
        </div>
        <VueStarRating
          class="shrink-0"
          :rounded-corners="true"
          :star-size="15"
          active-color="#ffb300"
          inactive-color="#f2f2f2"
          :border-width="3"
          border-color="#ffb300"
          :show-rating="false"
          :read-only="true"
          :increment="0.5"
          :rating="detail?.rating"
        ></VueStarRating>
        <div class="flex items-center gap-1 shrink-0" v-if="detail?.work_hours">
          <IconClock />{{ detail?.work_hours[getDay.toLowerCase()] }}
        </div>

        <div class="ml-auto flex gap-5 shrink-0">
          <button
            class="hover:bg-gray-100 active:bg-gray-200 px-2 rounded-full"
            @click="copy(source)"
          >
            <IconShare v-if="!copied" />
            <span v-else>Link copied!</span>
          </button>
          <ReportButton class="w-max !py-1.5 px-5"></ReportButton>
        </div>
      </div>
      <div class="w-full flex items-center justify-start gap-5 bg-white p-3 rounded-b">
        <button
          @click="tabIndex = 0"
          class="text-[#828282] text-base font-medium ml-2 cursor-pointer"
          :class="{
            'text-main-color border border-x-0 border-t-0 border-[#409DBA]': tabIndex === 0,
          }"
        >
          {{ $t('page.allProducts') }}
        </button>
        <button
          @click="tabIndex = 1"
          class="text-[#828282] text-base font-medium ml-2 cursor-pointer"
          :class="{
            'text-main-color border border-x-0 border-t-0 border-[#409DBA]': tabIndex === 1,
          }"
        >
          {{ $t('page.aboutStore') }}
        </button>
      </div>
    </div>
    <div v-if="tabIndex === 0">
      <div class="rounded-lg bg-white mb-4 flex gap-10 p-4">
        <div class="w-full">
          <div class="relative">
            <input
              @keyup.enter="searchProducts"
              type="text"
              v-model="currentSearch"
              class="block w-full p-5 text-sm .placeholder-accent-gray-color::placeholder text-main-color border border-[#e6e6e6] rounded-sm bg-white"
              :placeholder="$t('page.searchProductByName')"
            />

            <button
              @click="searchProducts"
              class="absolute z-10 inset-y-0 end-0 p-5 cursor-pointer flex items-center"
            >
              <IconSearch></IconSearch>
            </button>
          </div>
        </div>
        <SortButton
          v-if="currentRelevancy"
          @on-select="handleRelevancy"
          :options="SORT_OPTIONS"
          :defaultValue="currentRelevancy"
        ></SortButton>
      </div>
      <div class="rounded-lg bg-white mb-4 flex gap-4 p-4 min-w-0 overflow-hidden">
        <router-link :to="{ name: 'mallHome' }">
          <IconHome></IconHome>
        </router-link>
        >
        <router-link
          :to="{ name: 'storeDetail', params: { id: detail.id } }"
          class="truncate min-w-0 max-w-[300px]"
          :title="detail?.name"
        >
          {{ detail.name }}
        </router-link>
        <template v-if="getCategory">
          <div>></div>
          <div>
            <router-link
              :to="{
                name: 'storeDetail',
                params: { id: currentId },
                query: {
                  category: getCategory.id,
                  search: currentSearch,
                  ordering: currentSort,
                  cat: getCategory.id,
                },
              }"
            >
              {{ getCategory.name }}</router-link
            >
          </div>
        </template>
        <template v-if="getSubCategory">
          <div>></div>
          <div>
            <router-link
              :to="{
                name: 'storeDetail',
                params: { id: currentId },
                query: {
                  category: getSubCategory.id,
                  search: currentSearch,
                  ordering: currentSort,
                  cat: infoQuery.cat,
                  subcat: getSubCategory.id,
                },
              }"
            >
              {{ getSubCategory.name }}</router-link
            >
          </div>
        </template>
      </div>
      <div v-if="detail?.categories?.length > 0" class="flex flex-wrap gap-3">
        <p class="text-xl font-bold">{{ $t('page.categories') }}</p>

        <Splide
          class="w-full"
          :options="SPLIDE_PILL_OPTIONS"
          :has-track="false"
          aria-label="similars"
        >
          <SplideTrack class="pb-4">
            <template v-if="infoQuery.cat === undefined">
              <SplideSlide>
                <router-link
                  :to="{
                    name: 'storeDetail',
                    params: { id: currentId },
                    query: { search: currentSearch, ordering: currentSort },
                  }"
                  class="w-max flex px-4 cursor-pointer items-center gap-1 justify-center p-3 text-lg bg-white rounded-md border border-solid border-gp-grey-70"
                  :class="{ '!bg-main-color text-white': currentCategory == null }"
                >
                  {{ $t('page.all') }}</router-link
                >
              </SplideSlide>
              <SplideSlide v-for="(el, idx) in detail.categories" :key="idx">
                <router-link
                  :to="{
                    name: 'storeDetail',
                    params: { id: currentId },
                    query: {
                      category: el.id,
                      search: currentSearch,
                      ordering: currentSort,
                      cat: el.id,
                    },
                  }"
                  class="w-max flex px-4 cursor-pointer items-center gap-1 justify-center p-3 text-lg bg-white rounded-md border border-solid border-gp-grey-70"
                  :class="{ '!bg-main-color text-white': currentCategory == el.id }"
                >
                  {{ el.name }}</router-link
                >
              </SplideSlide>
            </template>
            <template v-else>
              <SplideSlide>
                <router-link
                  :to="{
                    name: 'storeDetail',
                    params: { id: currentId },
                    query: { search: currentSearch, ordering: currentSort },
                  }"
                  class="w-max h-full flex px-6 cursor-pointer items-center gap-1 justify-center p-3 text-lg bg-white rounded-md border border-solid border-gp-grey-70"
                  :class="{ '!bg-main-color text-white': currentCategory == null }"
                >
                  <IconArrowLeft2 class="scale-125" />
                </router-link>
              </SplideSlide>
              <SplideSlide v-for="(el, idx) in getCategory?.subcategories" :key="idx">
                <router-link
                  :to="{
                    name: 'storeDetail',
                    params: { id: currentId },
                    query: {
                      category: el.id,
                      search: currentSearch,
                      ordering: currentSort,
                      cat: infoQuery.cat,
                      subcat: el.id,
                    },
                  }"
                  class="w-max flex px-4 cursor-pointer items-center gap-1 justify-center p-3 text-lg bg-white rounded-md border border-solid border-gp-grey-70"
                  :class="{ '!bg-main-color text-white': currentCategory == el.id }"
                >
                  {{ el.name }}</router-link
                >
              </SplideSlide>
            </template>
          </SplideTrack>
        </Splide>
      </div>

      <hr class="my-2" />
      <div class="grid grid-cols-4 gap-5">
        <div class="col-span-1 max-lg:hidden">
          <div
            class="w-72 max-lg:bg-white max-lg:hidden max-lg:min-h-screen max-lg:px-8 max-lg:fixed max-lg:top-0 max-lg:left-0 max-lg:z-50"
            :class="{ 'max-lg:!block': filterState }"
          >
            <div class="divide-y-2 overflow-y-auto max-lg:h-[90vh]">
              <div class="my-5 py-5">
                <p class="font-semibold text-xl mb-4">{{ $t('nav.brands') }}</p>
                <div class="h-72 overflow-y-scroll fltrs">
                  <ul class="space-y-3 row-list">
                    <li>
                      <button
                        type="button"
                        class="text-main-color text-base font-semibold hover:text-accent-color"
                        :class="{ '!text-accent-color': currentBrands.length === 0 }"
                        @click="clearBrandFilter"
                      >
                        {{ $t('page.all') }}
                      </button>
                    </li>

                    <li v-for="brand in brands" :key="brand.id">
                      <label class="flex items-center justify-between gap-2 cursor-pointer">
                        <span class="flex gap-1 text-main-color text-base font-semibold">
                          {{ brand.name }}
                          <span class="text-red-400 text-sm">({{ brand.products__count }})</span>
                        </span>

                        <input
                          type="checkbox"
                          :checked="isBrandChecked(brand.id)"
                          @change="toggleBrand(brand.id)"
                        />
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-3 max-lg:col-span-4">
          <div class="grid grid-cols-3 gap-2 mt-5 max-lg:grid-cols-2">
            <router-link
              v-for="item in products"
              :key="item.id"
              :to="{ name: 'storeProductDetail', params: { id: item.id } }"
            >
              <StoreProductCard @likeAction="likeAction" :detail="item"></StoreProductCard>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="tabIndex === 1"
      class="w-full grid grid-cols-2 gap-16 bg-white p-8 rounded-b max-lg:grid-cols-1"
    >
      <div class="min-w-0">
        <div class="flex justify-between items-center text-main-color mb-3 gap-4 min-w-0">
          <p class="text-3xl font-bold min-w-0 flex-1 truncate" :title="detail?.name">
            {{ detail?.name }}
          </p>

          <div class="flex items-center gap-2 shrink-0">
            <IconEye></IconEye>
            <span class="font-bold text-sm">{{ detail?.view_count }}</span>
          </div>
        </div>
        <div class="text-[#333333] text-base pb-4 border-b border-[#E3E3E3]">
          <p class="font-light">{{ detail?.business_type }}</p>
        </div>
        <div class="mt-3">
          <p class="tetx-lg text-main-color mb-3">
            {{ $t('page.status') }}:
            <span class="font-semibold"
              >{{ detail?.subscription }} {{ detail?.is_vip ? ', VIP' : '' }}</span
            >
          </p>
          <p class="tetx-lg text-main-color mb-3">
            {{ $t('page.productCount') }}:
            <span class="font-semibold">{{ detail?.objects__count }}</span>
          </p>
          <p class="tetx-lg text-main-color mb-3">
            {{ $t('page.location') }}: <span class="font-semibold">{{ detail?.location }}</span>
          </p>

          <p v-if="detail?.phone" class="tetx-lg text-main-color mb-3">
            {{ $t('page.phoneNumbers') }}:
            <a :href="`tel:${detail.phone}`" class="font-semibold">{{ detail.phone }}</a>
          </p>
        </div>
      </div>
      <div class="min-w-0">
        <div class="accordion">
          <Accordion :label="$t('page.info')">
            <p>{{ detail?.description }}</p>
          </Accordion>
          <Accordion v-if="detail?.type == 0" :label="$t('page.phoneNumbers')">
            <div class="flex flex-col gap-2">
              <a
                v-for="(phone, index) in detail?.phone_numbers"
                :key="index"
                :href="`tel:${phone}`"
                >{{ phone }}</a
              >
            </div>
          </Accordion>

          <Accordion v-if="detail?.type == 0" :label="$t('nav.contact')">
            <div class="flex flex-col gap-2">
              <a v-for="(ct, index) in detail?.contacts" :key="index" :href="ct.value"
                >{{ CONTACT_TYPE_OPTIONS[ct.type] }}: {{ ct.value }}</a
              >
            </div>
          </Accordion>
          <Accordion :label="$t('page.workingHours')">
            <div class="flex flex-col gap-2">
              <p>
                <span class="font-semibold">{{ $t('page.monday') }}: </span
                >{{ detail?.work_hours?.monday }}
              </p>
              <p>
                <span class="font-semibold">{{ $t('page.tuesday') }}: </span
                >{{ detail?.work_hours?.tuesday }}
              </p>
              <p>
                <span class="font-semibold">{{ $t('page.wednesday') }}: </span
                >{{ detail?.work_hours?.wednesday }}
              </p>
              <p>
                <span class="font-semibold">{{ $t('page.thursday') }}: </span
                >{{ detail?.work_hours?.thursday }}
              </p>
              <p>
                <span class="font-semibold">{{ $t('page.friday') }}: </span
                >{{ detail?.work_hours?.friday }}
              </p>
              <p>
                <span class="font-semibold">{{ $t('page.saturday') }}: </span
                >{{ detail?.work_hours?.saturday }}
              </p>
              <p>
                <span class="font-semibold">{{ $t('page.sunday') }}: </span
                >{{ detail?.work_hours?.sunday }}
              </p>
            </div>
          </Accordion>
          <Accordion :label="$t('page.deliveryAbout')">
            <p>{{ detail?.delivery_policy }}</p>
          </Accordion>
          <Accordion :label="$t('page.deliveryTerms')">
            <DeliveryTerms :detail="detail" />
          </Accordion>
          <Accordion :label="$t('page.paymentRefund')">
            <p>{{ detail?.payment_policy }}</p>
          </Accordion>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import Accordion from '@cmp/Accordion.vue';
import DeliveryTerms from '@cmp/DeliveryTerms.vue';
import SortButton from '@cmp/SortButton.vue';
import StoreProductCard from '@cmp/mall/StoreProductCard.vue';
import IconEye from '@icons/IconEye.vue';
import IconShare from '@icons/IconShare.vue';
import IconSearch from '@icons/IconSearch.vue';
import IconHome from '@icons/IconHome.vue';
import IconClock from '@icons/IconClock.vue';
import IconArrowLeft2 from '@icons/IconArrowLeft2.vue';

import ReportButton from '@cmp/modals/buttons/ReportButton.vue';
import ReportModal from '@cmp/modals/ReportModal.vue';
import { ref } from 'vue';
import { useClipboard } from '@vueuse/core';
import { SORT_OPTIONS, SPLIDE_PILL_OPTIONS, CONTACT_TYPE_OPTIONS } from '@/constants';
import VueStarRating from 'vue-star-rating';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import { mapState } from 'pinia';
import { useAppStore } from '@/store';
import { isVideo } from '@/helpers';
export default {
  name: 'storeDetail',
  components: {
    Accordion,
    DeliveryTerms,
    SortButton,
    StoreProductCard,
    IconEye,
    IconShare,
    IconSearch,
    IconHome,
    Splide,
    SplideSlide,
    SplideTrack,
    VueStarRating,
    ReportModal,
    ReportButton,
    IconClock,
    IconArrowLeft2,
  },
  watch: {
    '$route.query.category': {
      //   immediate: true,
      async handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.currentCategory = newValue;
          this.infoQuery.cat = this.$route.query.cat;
          this.infoQuery.subcat = this.$route.query.subcat;
          this.infoQuery.subsubcat = this.$route.query.subsubcat;
          this.products = [];
          await this.getStoreProducts();
          await this.getBrands();
        }
      },
    },
    '$route.query.brand': {
      async handler(newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.currentBrands = this.normalizeBrandsQuery(newValue);
          this.products = [];
          await this.getStoreProducts();
        }
      },
    },
    '$route.query.ordering': {
      //   immediate: true,
      async handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.currentSort = newValue;
          this.products = [];
          await this.getStoreProducts();
        }
      },
    },
    '$route.query.search': {
      //   immediate: true,
      async handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.currentSearch = newValue;
          this.products = [];
          await this.getStoreProducts();
        }
      },
    },
  },
  setup() {
    const source = ref(window.location.href);
    const { text, copy, copied, isSupported } = useClipboard({ source });
    return {
      text,
      copy,
      copied,
      isSupported,
    };
  },
  data() {
    return {
      loading: false,
      bannersLoaded: false,
      detail: {},
      products: [],
      tabIndex: 0,
      brands: [],
      keyvideo: {},
      SORT_OPTIONS: SORT_OPTIONS,
      currentSort: '',
      currentRelevancy: null,
      currentCategory: null,
      currentSearch: null,
      currentBrands: [],
      SPLIDE_PILL_OPTIONS: SPLIDE_PILL_OPTIONS,
      CONTACT_TYPE_OPTIONS: CONTACT_TYPE_OPTIONS,
      infoQuery: {
        cat: undefined,
        subcat: undefined,
        subsubcat: undefined,
      },
    };
  },
  methods: {
    isVideo,
    async getStoreDetail() {
      this.loading = true;
      try {
        const response = await api.get(`mall/stores/${this.currentId}/`);
        this.detail = response.data;
        this.detail?.medias.forEach(element => {
          if (this.isVideo(element.path)) {
            let v = 'video' + element.id;
            this.keyvideo[v] = 1;
          }
        });
        this.bannersLoaded = true;
        await this.getBrands();
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    normalizeBrandsQuery(value) {
      if (Array.isArray(value)) {
        return value.filter(Boolean).map(String);
      }

      if (value === undefined || value === null || value === '') {
        return [];
      }

      return [String(value)];
    },

    cleanQuery(query) {
      Object.keys(query).forEach(key => {
        const value = query[key];

        if (
          value === undefined ||
          value === null ||
          value === '' ||
          value === false ||
          value === 'false' ||
          (Array.isArray(value) && value.length === 0)
        ) {
          delete query[key];
        }
      });

      return query;
    },

    serializeParams(params) {
      const searchParams = new URLSearchParams();

      Object.entries(params).forEach(([key, value]) => {
        if (
          value === undefined ||
          value === null ||
          value === '' ||
          value === false ||
          (Array.isArray(value) && value.length === 0)
        ) {
          return;
        }

        if (Array.isArray(value)) {
          value.forEach(item => {
            searchParams.append(key, item);
          });
          return;
        }

        searchParams.append(key, value);
      });

      return searchParams.toString();
    },

    isBrandChecked(brandId) {
      return this.currentBrands.map(String).includes(String(brandId));
    },

    async toggleBrand(brandId) {
      const id = String(brandId);
      const selectedBrands = this.currentBrands.map(String);

      if (selectedBrands.includes(id)) {
        this.currentBrands = selectedBrands.filter(item => item !== id);
      } else {
        this.currentBrands = [...selectedBrands, id];
      }

      await this.$router.push({
        name: 'storeDetail',
        params: { id: this.currentId },
        query: this.cleanQuery({
          ...this.$route.query,
          brand: this.currentBrands,
        }),
      });
    },

    async clearBrandFilter() {
      this.currentBrands = [];

      const query = { ...this.$route.query };
      delete query.brand;

      await this.$router.push({
        name: 'storeDetail',
        params: { id: this.currentId },
        query: this.cleanQuery(query),
      });
    },
    searchProducts() {
      if (this.currentSearch === '') {
        this.currentSearch = null;
      }

      this.$router.push({
        name: 'storeDetail',
        params: { id: this.currentId },
        query: this.cleanQuery({
          ...this.$route.query,
          category: this.currentCategory,
          search: this.currentSearch,
          ordering: this.currentSort,
          brand: this.currentBrands,
          cat: this.infoQuery.cat,
          subcat: this.infoQuery.subcat,
          subsubcat: this.infoQuery.subsubcat,
        }),
      });
    },
    async getStoreProducts() {
      this.loading = true;

      try {
        const response = await api.get(`mall/products/`, {
          params: {
            categories: this.currentCategory,
            store: this.currentId,
            search: this.currentSearch,
            ordering: this.currentSort,
            brand: this.currentBrands,
          },
          paramsSerializer: this.serializeParams,
        });

        this.products = response.data.results;
      } catch (e) {
        console.log(e);
      }

      this.loading = false;
    },
    async getBrands() {
      try {
        const response = await api.get('mall/brands/', {
          params: {
            store: this.currentId,
            category: this.currentCategory,
            location: this.getLocationId,
          },
        });

        this.brands = Array.isArray(response.data) ? response.data : response.data.results || [];
      } catch (e) {
        console.log(e);
      }
    },
    async likeAction(id, like) {
      if (this.$store.authStatus === false) {
        this.$store.setState('loginModal', true);
        return;
      }

      try {
        await api.post(`mall/products/${id}/like/`, { is_liked: like });
        this.$store.getLiked('mall');
      } catch (e) {
        console.log(e);
      }
    },

    handleRelevancy(e) {
      this.currentSort = e;
      this.searchProducts();
    },
    stopVideo() {
      this.detail?.medias.forEach(element => {
        if (this.isVideo(element.path)) {
          let v = 'video' + element.id;
          this.keyvideo[v] += 1;
        }
      });
    },
  },
  computed: {
    getSubcriptionType() {
      switch (this.detail?.subscription) {
        case 'Gold':
          return { color: 'bg-[#FABB18] text-black', name: 'Gold' };
        case 'Silver':
          return { color: 'bg-[#C0C0C0] text-black', name: 'Silver' };
        case 'Bronze':
          return { color: 'bg-[#AE7145] text-white', name: 'Bronze' };
        default:
          break;
      }
    },
    ...mapState(useAppStore, ['getMallCategory']),
    getCategory() {
      return this.detail?.categories?.find(el => el.id == this.infoQuery.cat);
    },
    getLocationId() {
      const location = this.getLocation;
      return typeof location === 'object' ? location?.id : location;
    },
    getSubCategory() {
      return this.getCategory?.subcategories?.find(el => el.id == this.infoQuery.subcat);
    },
    getDay() {
      if (this.detail?.work_hours) {
        let date = new Date();
        return date.toLocaleString('en-us', { weekday: 'long' });
      }
      return null;
    },
    getLocation() {
      return JSON.parse(localStorage.getItem('selectedLocation')) || 1;
    },
  },
  mounted() {},
  async created() {
    this.currentId = this.$route.params.id;
    this.currentCategory = this.$route.query.category;
    this.currentSearch = this.$route.query.search;
    this.currentSort = this.$route.query.ordering;
    this.currentBrands = this.normalizeBrandsQuery(this.$route.query.brand);
    this.infoQuery.cat = this.$route.query.cat;
    this.infoQuery.subcat = this.$route.query.subcat;
    this.infoQuery.subsubcat = this.$route.query.subsubcat;
    this.currentRelevancy = this.SORT_OPTIONS.filter(el => el.value == this.currentSort)[0];
    await this.getStoreDetail();
    await this.getStoreProducts();
  },
};
</script>
